export const hashArgs = (args: any[]): string => {
    return Buffer.from(JSON.stringify(args)).toString('hex');
}